module.exports = __webpack_public_path__ + "img/tuni-logo.c20b5d0d.gif";